var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTicket = function SvgIconTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.591 2.53a2.25 2.25 0 0 0-3.182 0L2.53 12.41a2.25 2.25 0 0 0 0 3.182l1.172 1.171c.51.511 1.227.42 1.66.162a1.25 1.25 0 0 1 1.713 1.713c-.257.433-.348 1.15.162 1.661L8.41 21.47a2.25 2.25 0 0 0 3.182 0l9.879-9.879a2.25 2.25 0 0 0 0-3.182l-1.172-1.172c-.51-.51-1.228-.419-1.66-.161a1.25 1.25 0 0 1-1.713-1.713c.257-.433.348-1.15-.163-1.661zM13.47 3.591a.75.75 0 0 1 1.06 0L15.6 4.659a2.75 2.75 0 0 0 3.742 3.742l1.068 1.069a.75.75 0 0 1 0 1.06L10.53 20.41a.75.75 0 0 1-1.06 0L8.4 19.341a2.75 2.75 0 0 0-3.742-3.742L3.591 14.53a.75.75 0 0 1 0-1.06z"
  })));
};
export default SvgIconTicket;